import { create } from 'zustand';

/**
 * Store global para cachear userDetails y evitar múltiples llamadas al backend
 * Todos los componentes que usen useComprasAuth compartirán esta caché
 */
export const useUserDetailsStore = create((set, get) => ({
  // Estado
  userDetails: null,
  loading: false,
  error: null,
  lastUsername: null,

  /**
   * Establece userDetails en el store
   */
  setData: (details, username) => {
    set({ 
      userDetails: details, 
      lastUsername: username, 
      loading: false, 
      error: null 
    });
  },

  /**
   * Marca como cargando
   */
  setLoading: (isLoading) => {
    set({ loading: isLoading });
  },

  /**
   * Registra un error
   */
  setError: (errorMsg) => {
    set({ error: errorMsg, loading: false });
  },

  /**
   * Limpia el caché
   */
  clear: () => {
    set({ userDetails: null, lastUsername: null, loading: false, error: null });
  },
}));
